import React from 'react'

import IncidentDetailsSection from './IncidentDetailsSection'
import IncidentDate from './IncidentDate'

import { useSelectedIncident } from '../hooks'

import styles from './IncidentDetails.module.css'

const detailFormat = (detail) =>
  (detail && detail.trim ? detail.trim() : detail) || '-'
const detailGroupFormat = (group) => {
  Object.keys(group).forEach((key) => (group[key] = detailFormat(group[key])))
  return group
}

const IncidentDetails = () => {
  const incident = useSelectedIncident()
  if (!incident) return null

  const {
    agencyNames,
    incidentDate,
    incidentNumber,
    reportNumbers,
    crimeCatDescr,
    primaryOfficerName1,
    primaryUnitId,
    location,
    apartment,
    commonPlace,
    building,
    floor,
    cityName,
    callerAddress,
    callerName,
    callerPhone,
    allComments,
  } = incident

  /* eslint-disable */
  const basic = detailGroupFormat({
    ['Agency']: Array.isArray(agencyNames) ? agencyNames.join(', ') : agencyNames,
    ['Date/Time']: <IncidentDate date={incidentDate} />,
    ['Incident Number']: incidentNumber,
    ['Report Number']: Array.isArray(reportNumbers) ? reportNumbers.join(', ') : reportNumbers,
    ['Description']: crimeCatDescr,
    ['Officer']: primaryOfficerName1,
    ['Primary Unit Id']: primaryUnitId,
  })

  const address = detailGroupFormat({
    ['Street']: location,
    ['Apt. Number']: apartment || commonPlace,
    ['Building']: building || floor,
    ['City']: cityName,
  })

  const caller = detailGroupFormat({
    ['Address']: callerAddress,
    ['Name']: callerName,
    ['Phone']: callerPhone,
  })
  /* eslint-enable */

  return (
    <div className={styles.details}>
      <IncidentDetailsSection title="Basic" details={basic} />
      <IncidentDetailsSection title="Address" details={address} />
      <IncidentDetailsSection title="Caller" details={caller} />
      <div className={styles.sectionTitle}>Comments</div>
      <span className={styles.comments}>{allComments}</span>
    </div>
  )
}

export default IncidentDetails
